<template>
  <div>
    <h5 class="mb-4">일일안전점검표</h5>
    <search-nav size="mobile" align="justify-end" @handleSearch="handleSearch">
      <search-nav-item-keyword class="w-full" size="mobile" label="키워드" v-model="nav.keyword"></search-nav-item-keyword>
      <search-nav-item-select class="w-full" size="mobile" label="차수" :list="nav.list" v-model="nav.orderNum" />
    </search-nav>
    <div style="margin:0 -1.2rem;">
      <vs-table
        style="border:1px solid #cdcdcd; border-radius: 0;"
        stripe
        ref="table"
        :sst="true"
        :max-items="table.perPage"
        :data="table.list"
        noDataText="'대상기간' 을 선택하거나, 키워드 검색을 진행하여 주세요."
        @sort="handleSort"
        @selected="handleItemClickDetail">

        <template slot="thead">
          <vs-th sort-key="id" style="min-width:130px;"><span class="w-full text-center">No.</span></vs-th>
          <vs-th sort-key="content$title" style="min-width:130px;"><span class="w-full text-center">사무소명</span></vs-th>
          <vs-th sort-key="contentd$orderNumber" style="min-width:130px;"><span class="w-full text-center">차수</span></vs-th>
          <vs-th sort-key="content$company" style="min-width:130px;"><span class="w-full text-center">소속</span></vs-th>
          <vs-th sort-key="content$date" style="min-width:130px;"><span class="w-full text-center">대상기간</span></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="text-center">{{ tr.id }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).title }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).orderNumber + '차' }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).company }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).date }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(table.lastPage) ? table.lastPage : 1"
            v-model="table.currentPage"
            @change="handleChangePage"
          ></k-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import KPagination from '@/views/components/kPagination/kPagination'
import PopupExcelDownload from '@/views/components/popup/PopupExcelDownload'
export default {
  name: 'RiskCheckDailySafetyChecklist',
  components: {
    PopupExcelDownload,
    KPagination,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNavItemSelect,
    SearchNav},
  data () {
    return {
      // 검색 네비게이션
      rootPath: '',
      nav:{
        date:['', ''],
        list:[],
        orderNum:'',
        keyword:'',
        orderTarget:'created_at',
        orderDirection:'desc'
      },

      table: {
        list:[],
        perPage:5,
        keyword:'',
        lastPage:1,
        currentPage:1
      },

      listAll: [],
      showExcelDownload: false
    }
  },

  computed: {
    excelList () {
      const list = []
      for (const data of this.listAll) {
        list.push({
          'No.': data.id,
          '사무소명': this.getPreview(data).title,
          '파트너사': this.getPreview(data).company,
          '차수':`${this.getPreview(data).orderNumber}차`,
          '대상기간': this.getPreview(data).date
        })
      }
      return list
    }
  },

  async created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}/${paths[3]}`

    await this.loadPostList()
    await this.loadOrderList()
  },

  methods:{
    async loadOrderList () {
      const page = 1
      const perPage = 10000
      const projectId = this.$route.params.proj_id
      await this.$store.dispatch('project/LOAD_PROJECT_ORDER', {page, perPage, projectId})
      const orderList = this.$store.state.project.orderList
      this.nav.list = []
      this.nav.list.push({value:'', text:'{선택안함}'})
      for (const order of orderList) {
        this.nav.list.push({value:order.order_number, text:`${order.order_number}차`})
      }
    },

    async loadPostList () {
      const projectId = this.$route.params.proj_id
      const boardId = 12
      const page = this.table.currentPage
      const perPage = this.table.perPage
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection
      const keyword = []
      if (this.nav.keyword) keyword.push(`content$preview.company*%${this.nav.keyword}%`)
      if (this.nav.orderNum) keyword.push(`contentd$preview.orderNumber*${this.nav.orderNum}`)

      await this.$store.dispatch('board/LOAD_POST_LIST', {projectId, boardId, page, perPage, keyword, orderTarget, orderDirection})
      const postListInfo = this.$store.state.board.postListInfo
      this.table.list = postListInfo.data

      // 페이지네이션 정보
      this.table.currentPage = postListInfo.current_page
      this.table.lastPage = postListInfo.last_page
      this.table.perPage = postListInfo.per_page

    },
    async loadPostListAll () {
      const projectId = this.$route.params.proj_id
      const boardId = 12
      const page = 1
      const perPage = 1000
      const keyword = []
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection
      if (this.nav.keyword) keyword.push(`content$preview.company*%${this.nav.keyword}%`)
      if (this.nav.orderNum) keyword.push(`contentd$preview.orderNumber*${this.nav.orderNum}`)

      await this.$store.dispatch('board/LOAD_POST_LIST', {projectId, boardId, page, perPage, keyword, orderTarget, orderDirection})
      const postListInfo = this.$store.state.board.postListInfo
      this.listAll = postListInfo.data

    },


    getPreview (data) {
      if (data.preview) {
        const preview = JSON.parse(data.preview)
        return preview
      }
    },


    handleItemClickDetail (data) {
      const postId = data.id
      this.$router.push({path: `${this.rootPath}/safety/${postId}/daily-check-detail`})

    },

    handleSort (key, type) {
      if (key) {
        this.nav.orderTarget = key
        this.nav.orderDirection = type
        this.loadPostList()
      }

    },

    handleChangePage (page) {
      this.table.currentPage = page
      this.loadPostList()
    },

    handleSearch () {
      this.loadPostList()
    },

    async excelDownFunc () {
      await this.loadPostListAll()
      this.showExcelDownload = true
    },
  }
}
</script>

<style scoped>

</style>
